import { ChevronDown, ChevronUp } from 'lucide-react-native';
import { Pressable, StyleSheet } from 'react-native';

import { Text } from '@/components/Text';
import { colors } from '@/constants/theme';

export type DisclosureToggleProps = {
  open: boolean;
  /** What it says ("Earlier videos (2)"); without one, the chevron alone (a step's fold). */
  label?: string;
  onPress: () => void;
  accessibilityLabel?: string;
  testID?: string;
};

/** A quiet "label ⌄ / ⌃" (or the chevron alone) that folds a section open or shut, with a 44pt touch target. */
export function DisclosureToggle({ open, label, onPress, accessibilityLabel, testID }: DisclosureToggleProps) {
  const Chevron = open ? ChevronUp : ChevronDown;
  return (
    <Pressable
      onPress={onPress}
      hitSlop={HIT_SLOP}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      accessibilityState={{ expanded: open }}
      style={({ pressed }) => [styles.toggle, pressed && styles.pressed]}
      testID={testID}
    >
      {label ? (
        <Text variant="captionBold" color="textMuted">
          {label}
        </Text>
      ) : null}
      <Chevron size={14} color={colors.textMuted} strokeWidth={2.5} />
    </Pressable>
  );
}

// 15pt around a bare 14pt chevron reaches the 44pt touch target (a line of text with it, more).
const HIT_SLOP = { top: 15, bottom: 15, left: 15, right: 15 };

const styles = StyleSheet.create({
  toggle: { flexDirection: 'row', alignItems: 'center', gap: 2 },
  pressed: { opacity: 0.6 },
});
